import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";

// import chooseImg from "../../assests/images/why-choose-us.png";
import "./choose-us.css";

import ReactPlayer from "react-player";

const chooseImg = `https://resources.jetbrains.com/storage/products/pycharm/img/meta/preview.png`;

const ChooseUs = () => {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <section>
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="choose__content">
              <h2>Заманауи маманның өзекті мәселесі</h2>
              <p>
                Заманауи маманның өзекті мәселесі болып отыр.
                Математика, физика және т.б. білім беру пәндері бойынша  практикалық тапсырмаларды орындау барысында дағдыларды және шешім қабылдауды  жүзеге асыруға болады. Әрбір техникалық маманның  міндетті түрде алгоритмдік және бағдарламалау дағдылары болуы қажет. Осы ұсынылып отырған оқу құралында әр түрлі бағдарламалау тілдерінің ішінен Python - жоғары деңгейлі бағдарламалау тілі таңдалды.
                Оқу құралы үй тапсырмаларын, графикалық – есептеу және бақылау жұмыстарын орындау кезінде өздік жұмыстарды дайындауда қамтамасыз етуге арналған.
              </p>
            </div>
          </Col>

          <Col lg="6" md="6">
            <div className="choose__img">
              {showVideo ? (
                <ReactPlayer
                  url="https://youtu.be/GNWDv_cE000"
                  controls
                  width="100%"
                  height="350px"
                />
              ) : (
                <img src={chooseImg} alt="" className="w-100" />
              )}

              {!showVideo && (
                <span className="play__icon">
                  <i
                    class="ri-play-circle-line"
                    onClick={() => setShowVideo(!showVideo)}
                  ></i>
                </span>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ChooseUs;
